// File: frontend/src/components/Dashboard/PipelineOverview.jsx
// Distribución del funil por etapa.
//
// Mismo lenguaje visual que LeadScoreChart (fila = etiqueta + conteo + % + barra
// sobre base común) para que las dos tarjetas del dashboard se lean como una sola
// pieza. Antes cada etapa era una caja con borde e icono: ocupaba el triple de
// alto y no dejaba comparar las etapas entre sí.

import React from 'react';

const STAGES = [
  { key: 'prospecting', name: 'Prospecção', description: 'Leads iniciais', bar: 'bg-blue-500', dot: 'bg-blue-500', value: 'text-blue-600 dark:text-blue-400' },
  { key: 'qualification', name: 'Qualificação', description: 'Leads qualificados', bar: 'bg-indigo-500', dot: 'bg-indigo-500', value: 'text-indigo-600 dark:text-indigo-400' },
  { key: 'proposal', name: 'Proposta', description: 'Em negociação', bar: 'bg-violet-500', dot: 'bg-violet-500', value: 'text-violet-600 dark:text-violet-400' },
  { key: 'closed', name: 'Fechados', description: 'Negócios finalizados', bar: 'bg-emerald-600', dot: 'bg-emerald-600', value: 'text-emerald-600 dark:text-emerald-400' },
];

const PipelineOverview = ({ data }) => {
  const stages = STAGES.map((s) => ({ ...s, count: Number(data?.[s.key]) || 0 }));
  const total = stages.reduce((sum, s) => sum + s.count, 0);

  return (
    <div className="bg-white dark:bg-gray-800 rounded-lg shadow-sm border border-gray-200 dark:border-gray-700 p-5 h-full flex flex-col">
      <div className="flex items-start justify-between mb-1">
        <h3 className="text-base font-semibold text-gray-900 dark:text-gray-100">
          Visão do Pipeline
        </h3>
        <span className="text-xs text-gray-500 dark:text-gray-400 whitespace-nowrap ml-2">
          {total} leads
        </span>
      </div>
      <p className="text-xs text-gray-500 dark:text-gray-400 mb-4">
        Distribuição por etapa do funil
      </p>

      {total > 0 ? (
        <div className="flex-1 flex flex-col justify-around gap-4">
          {stages.map((stage) => {
            const pct = (stage.count / total) * 100;
            return (
              <div key={stage.key}>
                <div className="flex items-baseline justify-between mb-1.5">
                  <div className="flex items-center gap-2 min-w-0">
                    <span className={`h-2 w-2 rounded-full flex-shrink-0 ${stage.dot}`} />
                    <span className="text-sm font-medium text-gray-700 dark:text-gray-200 truncate">
                      {stage.name}
                    </span>
                    <span className="text-xs text-gray-400 dark:text-gray-500 truncate hidden sm:inline">
                      {stage.description}
                    </span>
                  </div>
                  <div className="flex items-baseline gap-1.5 flex-shrink-0 ml-2">
                    <span className={`text-sm font-semibold tabular-nums ${stage.value}`}>
                      {stage.count}
                    </span>
                    <span className="text-xs text-gray-400 dark:text-gray-500 tabular-nums">
                      {pct.toFixed(0)}%
                    </span>
                  </div>
                </div>
                <div className="h-1.5 w-full rounded-full bg-gray-100 dark:bg-gray-700 overflow-hidden">
                  <div
                    className={`h-full rounded-full transition-all duration-300 ${stage.bar}`}
                    style={{ width: `${pct}%` }}
                  />
                </div>
              </div>
            );
          })}
        </div>
      ) : (
        <div className="flex-1 flex items-center justify-center text-center py-8">
          <div>
            <p className="text-sm text-gray-500 dark:text-gray-400">Nenhum dado de pipeline</p>
            <p className="text-xs text-gray-400 dark:text-gray-500 mt-1">
              Adicione leads para ver o funil
            </p>
          </div>
        </div>
      )}
    </div>
  );
};

export default PipelineOverview;
